"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScheduleTimeFormat = exports.ScheduleDateFormat = exports.ScheduleStruct = exports.ScheduleDateRangeStruct = exports.ScheduleTimeRangeStruct = void 0;
const superstruct_1 = require("superstruct");
const weekdays_1 = require("./weekdays");
exports.ScheduleTimeRangeStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    from: (0, superstruct_1.string)(),
    until: (0, superstruct_1.string)(),
    days: (0, superstruct_1.array)(weekdays_1.WeekdayStruct), // array of days (MO, TU, WE, TH, FR, SA, SU)
});
exports.ScheduleDateRangeStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    enabled: (0, superstruct_1.boolean)(),
    startDate: (0, superstruct_1.string)(),
    endDate: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    slotDurationMinutes: (0, superstruct_1.defaulted)((0, superstruct_1.number)(), 15),
    capacity: (0, superstruct_1.defaulted)((0, superstruct_1.number)(), 1),
    exemptions: (0, superstruct_1.defaulted)((0, superstruct_1.array)((0, superstruct_1.string)()), []),
    timeRanges: (0, superstruct_1.defaulted)((0, superstruct_1.array)(exports.ScheduleTimeRangeStruct), []),
    availabilityWindowStart: (0, superstruct_1.optional)((0, superstruct_1.number)()),
    availabilityWindowFinish: (0, superstruct_1.optional)((0, superstruct_1.number)()),
});
exports.ScheduleStruct = (0, superstruct_1.type)({
    id: (0, superstruct_1.string)(),
    name: (0, superstruct_1.defaulted)((0, superstruct_1.string)(), 'Default Schedule'),
    isAppointmentConfirmationEnabled: (0, superstruct_1.defaulted)((0, superstruct_1.boolean)(), false),
    color: (0, superstruct_1.optional)((0, superstruct_1.string)()),
    dateRanges: (0, superstruct_1.defaulted)((0, superstruct_1.array)(exports.ScheduleDateRangeStruct), []),
});
exports.ScheduleStruct.type = 'Schedule';
exports.ScheduleDateRangeStruct.type = 'ScheduleDateRange';
exports.ScheduleTimeRangeStruct.type = 'ScheduleTimeRange';
exports.ScheduleDateFormat = 'dd.MM.yyyy';
exports.ScheduleTimeFormat = 'HH:mm';
//# sourceMappingURL=schedule.js.map